import "./App.css";
import ToastMessage from "./common/toastMessage";
import AppRoutes from "./routes/appRoutes";
import PageLoader from "./common/pageLoader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import DashboardPageLoader from "./common/dashboardPageLoader";
import setHeaders from "./utils/setHeaders";
import keycloakService from "./modules/index";
import { useSelector } from "react-redux";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
}
window.addEventListener("unload", function () {
  keycloakService.doLogout();
});


function App() {

    useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    setHeaders();
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <ToastMessage />
      <PageLoader />
      <DashboardPageLoader />
      <AppRoutes />
    </div>
  );
}

export default App;
